import { Option } from 'types/Option';

export const BLANK_OPTION = { label: ' ', value: '', disabled: true } as Option;
export const BLANK_OPTION_ENABLED = { label: '\u00A0', value: '', disabled: false } as Option;
